import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import IcdCode from "models/codes/IcdCode";
import ContentWrapper from "models/content-wrapper/content-wrapper";
import { Order, OrderComponent } from "models/order-management/models";
import { OrderFormState } from "pages/orders-entry-om/add-order/order-form-state";
import { ReferralsServiceProvider } from "providers/patient-charts/referrals-service";
import { take } from "rxjs/operators";
import { DiagnosisData } from "../../../pages/patient-chart/diagnosis/models/diagnosis-data";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import {
  OrderComponentInterface,
  OrderComponentPropertyUpdate,
  OrderCreateRequestUpdate,
} from "../order-components-interface";

@Component({
  selector: "diagnosis-search",
  templateUrl: "diagnosis-search.html",
})
export class OrderingSearchInputComponent implements OrderComponentInterface {
  /****************************************************************************
   * Inputs                                                                   *
   ****************************************************************************/
  @Input() orderComponent: OrderComponent;
  @Input() orderCreateRequest: Order;
  @Input() orderFormState: OrderFormState;

  /****************************************************************************
   * Outputs                                                                  *
   ****************************************************************************/
  @Output() orderCreateRequestEvent =
    new EventEmitter<OrderCreateRequestUpdate>();
  @Output() orderFormStateEvent = new EventEmitter<OrderFormState>();
  @Output() isValidEvent = new EventEmitter<boolean>();
  @Output() amendedOrderRequestEvent =
    new EventEmitter<OrderComponentPropertyUpdate>();

  /****************************************************************************
   * State                                                                    *
   ****************************************************************************/
  icdCodes: any = [];
  diagnosisTypeBeingChanged: string;
  hideIcdCodeDropdownMenu = true;
  diagnosisType: string = "";
  selectedDiagnosisDesc: string;
  selectedDiagnosis: any;
  locations: any = [];
  textFieldValue = "";
  diagnosisData: DiagnosisData = {
    primary: null,
    secondary: null,
    related: [],
    unrelated: [],
  };
  icdCodeDesc = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public stateData: StateManagementService,
    public referralService: ReferralsServiceProvider
  ) {}

  /****************************************************************************
   * Lifecycle Methods                                                        *
   ****************************************************************************/
  ngOnInit() {
    this.diagnosisType = "";
  }

  /****************************************************************************
   * Getter Methods                                                           *
   ****************************************************************************/
  getIcdCodes(searchTerm) {
    this.referralService
      .getIcdCodeSearch(searchTerm)
      .pipe(take(1))
      .subscribe((response: ContentWrapper<IcdCode>) => {
        this.icdCodes = response.content;
      });
  }

  /****************************************************************************
   * Setter Methods                                                           *
   ****************************************************************************/
  setDiagnosisTypeBeingChanged(diagnosisType: string) {
    this.diagnosisTypeBeingChanged = diagnosisType;
  }

  setDiagnosis(icdCode: IcdCode) {
    this.hideIcdCodeDropdownMenu = true;
    this.icdCodeDesc = this.selectedDiagnosisDesc =
      icdCode.code + " - " + icdCode.description;
    this.orderCreateRequestEvent.emit({
      updates: {
        diagnosis: icdCode.code,
        diagnosisDescription: icdCode.description,
      },
    });
    this.selectedDiagnosis = icdCode;
  }

  /****************************************************************************
   * Component Related Methods                                                *
   ****************************************************************************/
  searchDiagnosis(event) {
    const searchTerm = event.value;
    if (
      searchTerm &&
      searchTerm.length >= 3 &&
      this.icdCodeDesc !== this.selectedDiagnosisDesc
    ) {
      if (
        this.icdCodes.filter((issue) => issue.name === searchTerm).length ===
          0 &&
        searchTerm !== ""
      ) {
        this.hideIcdCodeDropdownMenu = false;
        this.getIcdCodes(searchTerm);
      }
    } else if (this.icdCodeDesc === this.selectedDiagnosisDesc) {
      this.hideIcdCodeDropdownMenu = true;
    }
    this.checkIsValid();
  }

  checkIsValid() {
    if (this.selectedDiagnosisDesc !== "") {
      this.isValidEvent.emit(true);
    } else {
      this.isValidEvent.emit(false);
    }
  }

  /****************************************************************************
   * Cypress-Related ("data-cy") Methods                                      *
   ****************************************************************************/
  toKebabCase(label: string): string {
    if (label) {
      return label
        .replace(/^\s+|\s+$/gm, "")
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, "-")
        .toLowerCase();
    }
    return "";
  }

  createDataCyAttribute(component: string, option: string): string {
    return `${this.toKebabCase(component)}-option-${this.toKebabCase(option)}`;
  }
}



// WEBPACK FOOTER //
// ./src/components/order-management/diagnosis-search/diagnosis-search.ts